import React from 'react';
import { Link } from 'react-router-dom';
import MoleculeImage from './MoleculeImage';
import './ReactionCard.css';

const ReactionCard = ({ reaction, linkPrefix = '/reaction/' }) => {
  const reactants = reaction.molecules.filter(m => m.role === 'reactant');
  const products  = reaction.molecules.filter(m => m.role === 'product');
  const reagents  = reaction.molecules.filter(m => m.role === 'reagent');

  return (
    <Link to={`${linkPrefix}${reaction.record_number}`} className="reaction-card">
      <div className="reaction-card-header">
        <h3>Reaction #{reaction.record_number}</h3>
        <span className="reaction-type">{reaction.reaction_type}</span>
      </div>

      <div className="reaction-scheme">
        {reactants.slice(0, 2).map((mol, idx) => (
          <div key={idx} className="molecule-group-full">
            <div className="group-label">Reactant</div>
            <div className="molecule-cell">
              <MoleculeImage molId={mol.id} smiles={mol.smiles} width={200} height={200} />
            </div>
          </div>
        ))}
        {reactants.length > 2 && <div className="more-molecules">+{reactants.length - 2}</div>}

        <div className="scheme-arrow">
          {reagents.slice(0, 2).map((mol, idx) => (
            <div key={idx} className="molecule-group-full">
              <div className="group-label">Reagent</div>
              <div className="molecule-cell">
                <MoleculeImage molId={mol.id} smiles={mol.smiles} width={130} height={130} />
              </div>
            </div>
          ))}
          {reagents.length > 2 && <div className="more-molecules">+{reagents.length - 2}</div>}
          <div className="arrow-line">→</div>
        </div>

        {products.slice(0, 2).map((mol, idx) => (
          <div key={idx} className="molecule-group-full">
            <div className="group-label">Product</div>
            <div className="molecule-cell">
              <MoleculeImage molId={mol.id} smiles={mol.smiles} width={200} height={200} />
            </div>
          </div>
        ))}
        {products.length > 2 && <div className="more-molecules">+{products.length - 2}</div>}
      </div>

      <div className="reaction-card-footer">
        <span className="reagent-table">{reaction.reagent_table}</span>
        {reaction.url && <span className="has-url">🔗</span>}
      </div>
    </Link>
  );
};

export default ReactionCard;
